import isBodyWeightExerciseUtil from '@gymaholic/packages/src/modules/exercise/model/utils/is-body-weight/index.js'
import {
  EQUIPMENT_MESSAGE,
  EXERCISE_KEY,
  getEquipmentExerciseUtil
} from '@gymaholic/packages'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { defineMessages } from 'react-intl'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'

const messages = defineMessages({
  bodyweight: {
    id: 'getEquipmentStrByIdExerciseSelectorUtil.bodyweight',
    defaultMessage: 'The {exerciseName} is a bodyweight exercise, so it does not require any equipment. You can do it anywhere, at the gym or at home.'
  },
  bodyweightShort: {
    id: 'getEquipmentStrByIdExerciseSelectorUtil.bodyweightShort',
    defaultMessage: 'It does not require any equipment. You can do it at the gym or at home.'
  },
  equipmentList: {
    id: 'getEquipmentStrByIdExerciseSelectorUtil.equipmentList',
    defaultMessage: 'To perform {exerciseName} you need {equipmentListStr}.'
  },
  equipmentListShort: {
    id: 'getEquipmentStrByIdExerciseSelectorUtil.equipmentListShort',
    defaultMessage: 'You need {equipmentListStr} to perform it.'
  }
})

/**
 * @param props
 * @param props.exercise
 * @param props.intl
 * @param props.isShort
 */
function getEquipmentStrByIdExerciseSelectorUtil (props) {
  const {
    intl,
    exercise,
    isShort
  } = props

  const isBodyWeight = isBodyWeightExerciseUtil(exercise)
  const exerciseName = getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
  if (isBodyWeight) {
    return (
      formatMessageIntlUtil(
        intl,
        isShort ? messages.bodyweightShort : messages.bodyweight,
        { exerciseName }
      )
    )
  }

  const equipment = getEquipmentExerciseUtil(exercise)
  const equipmentListStr = equipment.map(equipmentItem => {
    return formatMessageIntlUtil(
      intl,
      EQUIPMENT_MESSAGE[equipmentItem]
    )
  }).join(', ')

  return (
    formatMessageIntlUtil(
      intl,
      isShort ? messages.equipmentListShort : messages.equipmentList,
      {
        exerciseName,
        equipmentListStr
      }
    )
  )
}

export default getEquipmentStrByIdExerciseSelectorUtil
